module.exports = [
    { key: '01', name: '汉族' },
    { key: '02', name: '蒙古族' },
    { key: '03', name: '回族' },
    { key: '04', name: '藏族' },
    { key: '05', name: '维吾尔族' },
    { key: '06', name: '苗族' },
    { key: '07', name: '彝族' },
    { key: '08', name: '壮族' },
    { key: '09', name: '布依族' },
    { key: '10', name: '朝鲜族' },
    { key: '11', name: '满族' },
    { key: '12', name: '侗族' },
    { key: '13', name: '瑶族' },
    { key: '14', name: '白族' },
    { key: '15', name: '土家族' },
    { key: '16', name: '哈尼族' },
    { key: '17', name: '哈萨克族' },
    { key: '18', name: '傣族' },
    { key: '19', name: '黎族' },
    { key: '20', name: '傈僳族' },
    { key: '21', name: '佤族' },
    { key: '22', name: '畲族' },
    { key: '23', name: '高山族' },
    { key: '24', name: '拉祜族' },
    { key: '25', name: '水族' },
    { key: '26', name: '东乡族' },
    { key: '27', name: '纳西族' },
    { key: '28', name: '景颇族' },
    { key: '29', name: '柯尔克孜族' },
    { key: '30', name: '土族' },
    { key: '31', name: '达斡尔族' },
    { key: '32', name: '仫佬族' },
    { key: '33', name: '羌族' },
    { key: '34', name: '布朗族' },
    { key: '35', name: '撒拉族' },
    { key: '36', name: '毛南族' },
    { key: '37', name: '仡佬族' },
    { key: '38', name: '锡伯族' },
    { key: '39', name: '阿昌族' },
    { key: '40', name: '普米族' },
    { key: '41', name: '塔吉克族' },
    { key: '42', name: '怒族' },
    { key: '43', name: '乌孜别克族' },
    { key: '44', name: '俄罗斯族' },
    { key: '45', name: '鄂温克族' },
    { key: '46', name: '德昂族' },
    { key: '47', name: '保安族' },
    { key: '48', name: '裕固族' },
    { key: '49', name: '京族' },
    { key: '50', name: '塔塔尔族' },
    { key: '51', name: '独龙族' },
    { key: '52', name: '鄂伦春族' },
    { key: '53', name: '赫哲族' },
    { key: '54', name: '门巴族' },
    { key: '55', name: '珞巴族' },
    { key: '56', name: '基诺族' },
    { key: '97', name: '其他' },
    { key: '98', name: '外国血统中国籍人士' },
]



// WEBPACK FOOTER //
// ./src/config/dict/nation.js